class OnlineDetector {
    detect() {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open("GET", "/rpc/session/user-info", true);

            xhr.timeout = 5000;

            xhr.onload = () => {
                SessionManager.offlineMode = false;
                resolve();
            };

            xhr.ontimeout = (e) => {
                SessionManager.offlineMode = true;
                resolve();
            };

            xhr.onerror = () => {
                SessionManager.offlineMode = true;
                resolve();
            };

            try {
                xhr.send(null);
            }
            catch (e) {
                SessionManager.offlineMode = true;
            }
        });
    }
}
const instance = new OnlineDetector();
export default instance;
